module.exports = __webpack_public_path__ + "img/momo_2.66b268db.png";